'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = style;

var _glamorReact = require('glamor-react');

var _colors = require('../styles/colors');

var _helpers = require('../styles/helpers');

function style(fill, size, bgColor, textColor) {
  return (0, _glamorReact.css)((0, _helpers.size)(size), bgColor ? (0, _colors.background)(bgColor) : null, (0, _colors.text)(textColor), {
    fill: fill,
    display: 'inline-block',
    userSelect: 'none'
  });
}


//////////////////
// WEBPACK FOOTER
// ./~/tanda-components/Icon/styles.js
// module id = 1584
// module chunks = 0